import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Employee } from 'src/app/models/employee.model';
import { ServiceProvider } from 'src/app/models/service_provider.model';
import { ServiceProviderService } from 'src/app/services/service_provider_service.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import {ProviderDataDialogComponent} from "./provider_data_dialog/provider_data_dialog.component";
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'provider-table',
    templateUrl: './provider_table.component.html',
    styleUrls: ['./provider_table.component.scss'],
    imports: [MatProgressBar, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIconButton, MatTooltip, MatIcon, MatMenuTrigger, MatMenu, MatMenuItem, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow, DatePipe]
})
export class ProviderTableComponent implements OnInit {

    employee!: Employee;

    serviceProviders: ServiceProvider[] = [];
    serviceProviderDataSource = new MatTableDataSource<ServiceProvider>([]);
    serviceProviderColumnHeaders: string[] = [
        'name',
        'businessName',
        'dateCreated',
        'primaryPhoneNumber',
        'secondaryPhoneNumber',
        'emailAddress',
        'address',
        'action'
    ];

    loading = false;

    constructor(
        private serviceProviderService: ServiceProviderService,
        private tokenStorageService: TokenStorageService,
        private router: Router,
        public dialog: MatDialog,
    ) { }

    ngOnInit(): void {
        this.employee = this.tokenStorageService.getUser();
        if (this.employee.employeeRole === 'Admin') {
            this.getAllProviders();
        } else {
            this.router.navigate(['home']);
        }
    }

    getAllProviders(): void {
        this.loading = true;

        this.serviceProviderService
            .getAll([], new Map())
            .subscribe(serviceProviders => {
                this.serviceProviders = serviceProviders;
                this.refreshProvidersTable();
                this.loading = false;
            }, _ => {
                this.loading = false;
            });
    }

    refreshProvidersTable(): void {
        this.serviceProviderDataSource.data = this.serviceProviders;
    }

    openProviderDataDialog(serviceProvider: ServiceProvider): void {
      this.dialog.open(ProviderDataDialogComponent, {data: {providerId: serviceProvider.serviceProviderId}});
    }
}
